// BookStatusBar.js
import React from 'react';
import './BookStatusBar.css';

const STAGES = [
  'Not Started',
  'Drafting',
  'Revising',
  'Final Revision',
  'Editor',
  'Published',
];

export default function BookStatusBar({ status = 0 }) {
  return (
    <div className="status-container">
      {STAGES.map((label, index) => {
        const step = index + 1;
        const isComplete = status > step;
        const isCurrent = status === step;

        return (
          <div key={label} className="status-step">
            <div
              className={`status-circle ${
                isComplete ? 'complete' : isCurrent ? 'current' : ''
              }`}
            >
              {step}
            </div>
            <div className="status-label">{label}</div>
            {step < STAGES.length && (
              <div className={`status-line ${status > step ? 'complete' : ''}`} />
            )}
          </div>
        );
      })}
    </div>
  );
}
